module.exports = __webpack_public_path__ + "static/media/postcardRetro3.d87acdfb.jpg";